<template>
  <div
    class="book_surgery toggleContainer desk_inner_width"
    :class="{ active: isOpen }"
    ref="phisycal_check"
  >
    <a
      class="book_surgery_top flex"
      href="javascript:void(0)"
      @click.prevent="isOpen = !isOpen"
    >
      <span class="title flex is--fit desk-flex--between">
        <span>בדיקה גופנית*</span>
        <Tags :isDoctor="true" :isRequired="true" />
      </span>
      <span class="plus-wrap flex m-flex--center">
        <span class="plus"></span>
      </span>
    </a>
    <div v-show="isOpen" class="book_surgery_open toggleInner">
      <div class="inner_group bg--white desk-no-pad">
        <div class="add_new_row flex desk-w-100 desk-no-pad">
          <div class="add_new_row_col1 w-100">פרט תוצאות בדיקה גופנית</div>
          <div class="input_area_opcity textarea-big only-doc-mark">
            <div class="only-doc-mark-in">למילוי ע״י הרופא</div>
            <validation-provider
              name="phisycal_check"
              rules="required"
              v-slot="{ errors }"
            >
              <textarea
                v-model="physicalExamination"
                placeholder="פירוט..."
                autocomplete="off"
              ></textarea>
              <span class="error-message">{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Tags from "@/components/Dashboard/Surgery/AddSurgery/Steps/SurgeryDetails/modules/Tags.vue";

/**
 * PhysicalCheck Component
 * Handles the physical examination section for surgery
 * For doctor's use only - required field
 */
export default {
  name: "PhysicalCheck",
  components: {
    Tags
  },
  data() {
    return {
      isOpen: true
    };
  },
  computed: {
    ...mapState("Surgery", {
      surgery: state => state.surgery
    }),

    physicalExamination: {
      get() {
        return this.surgery.phisycal_check || "";
      },
      set(value) {
        this.SET_SURGERY({ phisycal_check: value });
      }
    }
  },
  methods: {
    ...mapMutations("Surgery", ["SET_SURGERY"])
  }
};
</script>
